import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withLocalize } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { Translate } from 'react-localize-redux';
import { popupActions } from '../../../store/popupStore';
import Lien from './lien';
import Money from '../../common/moneyComponent';
import RelationLink from '../relations/relationLink';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';

class LienGroup extends React.Component {
    state = {
        detailOpen: false
    }

    getDebtorLabel = (subjectType) => {
        switch (subjectType) {
            case "CR": return "Report.Liens.Debtor";
            case "DE": return "Report.Liens.Creditor";
            default: return "";
        }
    }

    render() {
        let subjectType = "";
        if (this.props.subjectType === "CR")
            subjectType = this.props.translate("Report.Liens.Debtor");
        else if (this.props.subjectType === "DE")
            subjectType = this.props.translate("Report.Liens.Creditor");

        return (
            <>
                <tr className={classnames("colorize", { "old-style-table-report-history-row": !this.props.group.parentLien.active })}>
                    <td data-label={this.props.translate("Search.Liens.Liabilities.Type")} title={this.props.subjectTypeName}>
                        <span>{this.props.subjectTypeName[0]}</span>
                    </td>
                    <td data-label={this.props.translate("Report.Liens.FileMark")}>
                        <span>{this.props.group.parentLien.fileMark.replace('NCRzp ', '')}</span>
                    </td>
                    <td data-label={subjectType} className='ellipsed-column'>
                        {this.createLinks(this.props.group.parentLien.relatedSubjects
                            .filter(i => i.typeId === (this.props.subjectType === 'CR' ? 'DE' : 'CR'))
                            .map(subject => subject)
                            .filter((item, pos, self) => self.findIndex(i => i.name === item.name) === pos))
                        }
                    </td>
                    <td data-label={this.props.translate("Report.Liens.Type")}><span>
                        {this.props.group.parentLien.debts
                            .map(debt => debt.type)
                            .filter((item, pos, self) => self.indexOf(item) === pos) // distinct
                            .join(", ")
                        }
                    </span></td>
                    <td style={{textAlign: "right"}} data-label={this.props.translate("Report.Liens.Price")}>
                        {this.props.group.parentLien.debts
                            .reduce((prev, debt) => {
                                const amountInfo = prev.find(p => p.currency === debt.currency);
                                if (amountInfo === undefined)
                                    prev.push({ currency: debt.currency, price: debt.price > 0 ? debt.price : debt.maxPrice });
                                else
                                    amountInfo.price += debt.price > 0 ? debt.price : debt.maxPrice;
                                return prev;
                            }, [])
                            .map(amountInfo => amountInfo.price)
                            .map((price, index) => <span key={index}>
                                {index === 0 ? (price > 0 && <Money value={price} fractionDigits={2} />)
                                    : <><span> / </span>{price > 0 && <Money value={price} fractionDigits={2} />}</>}
                            </span>)
                        }
                    </td>
                    <td data-label={this.props.translate("Report.Liens.Currency")}><span>
                        {this.props.group.parentLien.debts
                            .map(debt => debt.currency)
                            .filter((item, pos, self) => self.indexOf(item) === pos) // distinct
                            .join(" / ")
                        }
                    </span></td>
                    <td style={{textAlign: "right"}} data-label={this.props.translate("Report.Liens.Date")}>
                            {this.props.group.parentLien.startDateFormated}
                    </td>
                    <td style={{textAlign: "right"}}>
                        <span className="link-functional" onClick={() => this.onDetailClick()}>
                            <Translate id={"Report.Detail"} />
                        </span>
                    </td>
                </tr>
                {this.state.detailOpen && this.renderDetailTable(this.props.group.relatedLiens, !this.props.group.parentLien.active)}
            </>
        );
    }

    renderDetailTable = (data, isHistorical) => {
        return (
            <tr className="without-strip">
                <td colSpan={8}>
                    <OldStyleTableWithHistory stripped noMargin tableColumns={4} classNames={{ "old-style-table-report-history": isHistorical }}
                        resolveExpanded={this.props.resolveExpanded}
                        head={() => <thead>
                            <tr className="liens-head">
                                <th style={{ width: "12em" }}><Translate id="Report.Liens.FileMark" /></th>
                                <th><Translate id="Report.Liens.Type" /></th>
                                <th style={{ width: "12em" }}><Translate id="Report.Liens.Date" /></th>
                                <th style={{ width: "5em" }}></th>
                            </tr>
                        </thead>}
                        actualData={data}
                        actualRow={(r) => <Lien key={r.lienId} lien={r} isHistorical={isHistorical} />}
                    />
                </td>
            </tr>
        );
    }

    createLinks = (subjects) => {
        let links = [];
        subjects.forEach(s => {
            links.push(<RelationLink key={s.entityId} entityId={s.entityId} entityName={s.name} reports={s.reports} showOnMobile={true}></RelationLink>)
        });
        return links;
    }

    onDetailClick = () => {
        window.innerWidth <= 992 ? this.openPopup() : this.openDesktop();
    }

    openDesktop = () => {
        this.setState({ detailOpen: !this.state.detailOpen });
    }

    openPopup = () => {
        this.props.showPopup("lienPopup", {
            open: true,
            close: () => this.closePopup(),
            data: this.props.group.relatedLiens
        });
    }

    closePopup = () => {
        this.props.hidePopup();
    }
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(popupActions, dispatch)
)(LienGroup));